<template>
    <div class="profile-board test-editor-results">

      <h2 v-if="(loading.results || loading.candidate)">Загрузка...</h2>
      <h2 v-else-if="!res">Тест не завершен</h2>

        <div v-else class="row mt-2 mt-md-8">
            <div class="col-12 pa-3">
                <h3 class="rep-test-title">{{ testData.name }}</h3>
                <hr class="mt-7 mb-4">

                    <!-- <pre>{{ tabInfo.testData }}</pre> -->
                    <div class="profnavigator-list">
                        <div v-for="(prof, indProf) in positions(testData)" :key="indProf" class="profnavigator-item">
                            <!-- <Scale10Blocks :value="prof.value"></Scale10Blocks> -->
                            <div class="profnavigator-bar-col">
                                <div v-if="hasIntervals(prof)" class="profnavigator-scale-names">
                                    <div v-for="interval in prof.intervals" :key="interval.id"
                                        class="profnavigator-scale-name" :style="getIntervalLabelStyle(prof, interval)">
                                        {{ interval.subtitle }}
                                    </div>
                                </div>
                                <div class="profnavigator-scaleline">
                                    <div v-for="block in getScaleLimit" :key="block" class="profnavigator-item-block"
                                        :class="getBlockClass(prof, indProf, block)" :style="getBlockStyle(prof, block)" />
                                </div>
                            </div>
                            <div class="profnavigator-item-value">{{ getProfValue(prof) }}</div>
                            <div class="profnavigator-item-title">{{ prof.block ? prof.block.title : "Без названия" }}</div>
                        </div>
                    </div>
                    <h4 class="desc-title">{{ testData.test_results_title ? testData.test_results_title : '' }} </h4>
                    <p v-if="testData.test_results_description">
                        {{ testData.test_results_description }}
                    </p>
                    <!-- <p v-else>
                        Ниже представлены 3 ключевых направления деятельности, к которым Вы проявили наибольший интерес. Развиваясь в данных направлениях, Вы можете добиться большего успеха, так как данные направления деятельности Вас будут мотивировать в Вашей работе
                        Для успешного освоения профессий Вам может понадобиться пройти дополнительное обучение, обратитесь за информацией к консультанту или работодателю.
                    </p> -->
                    <div v-for="(prof, indProf) in top3positions(testData)" :key="indProf" class="desc-item">
                        <div class="desc-item-title">{{ prof.block ? prof.block.title : "Без названия" }}</div>
                        <div class="desc-item-text" v-html="renderText(prof.text)" />
                        <!-- Рекомендации на саму платформу вообще не идут - только описание -->
                        <!-- <template v-if="prof.recommendation">
                            <div class="desc-item-title">Рекомендации</div>
                            <div class="desc-item-text" v-html="renderText(prof.recommendation)" />
                        </template> -->
                    </div>
            </div>
        </div>

    </div>
</template>

<script>
/* eslint-disable */
import Scale10Blocks from "../ui/Scale10ColorBlocks.vue";
import { prepareText, sanitizeRichHtml } from "@/common/util"
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        Scale10Blocks
    },
    data() {
        return {
        };
    },
    props: ['testCode'],
    computed: {
        ...mapGetters({
            user: 'auth/user',
            res: 'users/candidate/results',
            loading: 'users/candidate/loading',
            loadingCandidate: 'users/candidate/loading',
        }),
        getScaleLimit() {
            return 10;
        },
        testData() {
            return this.res?.constructor_test_results && this.res.constructor_test_results[this.testCode] 
                ? this.res.constructor_test_results[this.testCode] 
                : { name: "Отчет не найден", blocks: [] }
        },
        candidateId() {
            return this.user.user_type === CANDIDATE ? this.user.id : this.$route.params.id;
        },
    },
    methods: {
        ...mapActions({
        }),
        prepareText,
        // Бэк для VALUES отдаёт text/recommendation уже готовым HTML (h3/strong/p с
        // text-align), как в rich-text редакторе экспертного заключения — такой контент
        // нужно санитизировать через DOMPurify (sanitizeRichHtml), а не экранировать как
        // построчный plain-текст (prepareText), иначе разметка уходит на экран текстом.
        // Проверяем сначала только на VALUES, остальные constructor-тесты пока
        // присылают обычный текст и продолжают работать через prepareText.
        renderText(text) {
            return this.testCode === 'VALUES' ? sanitizeRichHtml(text) : prepareText(text)
        },
        positions(testData) {
            const arr = [...testData.blocks]
            arr.sort((a, b) => b?.value - a?.value)
            return arr
        },
        top3positions(testData) {
            if (this.testCode==='MOSTURISM')
                return this.positions(testData).slice(0, 3)
            else
                return this.positions(testData)
        },
        getProfValue(item) {
            // Тесты с intervals (напр. VALUES) приходят нормализованными к 0-100,
            // а не к 0-10, как остальные constructor-тесты на этой шкале — см. pdf-generator
            // render/handlebarsHelpers/constructorValues.js.
            if (this.hasIntervals(item)) {
                let v = Math.round(item.value)
                if (v < 0) v = 0;
                if (v > 100) v = 100;
                return v
            }
            let v = Math.round(item.value)
            if (v < 0) v = 0;
            if (v > 10) v = 10;
            return v
        },
        hasIntervals(prof) {
            return Array.isArray(prof.intervals) && prof.intervals.length > 0
        },
        getValueFloor(prof) {
            let v = Math.round(prof.value)
            if (v < 0) v = 0;
            if (v > 100) v = 100;
            return Math.floor(v / 10)
        },
        getMainColor(prof) {
            const interval = prof.intervals.find(el => el.id === prof.matched_interval)
            return interval ? interval.color : '#39A9DC'
        },
        getIntervalLabelStyle(prof, interval) {
            if (interval.id === prof.matched_interval)
                return { color: interval.color, fontWeight: 600 }
            return {}
        },
        // Портировано из pdf-generator render/util.js (getGradientColorByIndex), чтобы
        // закрашенные сегменты шкалы выглядели так же, как в PDF-отчёте — светлее к началу,
        // насыщеннее у текущего значения.
        hexToRgb(hex) {
            let h = hex.replace('#', '')
            if (h.length === 3) h = h.split('').map(c => c + c).join('')
            const num = parseInt(h, 16)
            return [(num >> 16) & 255, (num >> 8) & 255, num & 255]
        },
        rgbToHsl(r, g, b) {
            r /= 255; g /= 255; b /= 255
            const max = Math.max(r, g, b), min = Math.min(r, g, b)
            let h, s
            const l = (max + min) / 2
            if (max === min) {
                h = s = 0
            } else {
                const d = max - min
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
                switch (max) {
                    case r: h = (g - b) / d + (g < b ? 6 : 0); break
                    case g: h = (b - r) / d + 2; break
                    default: h = (r - g) / d + 4; break
                }
                h /= 6
            }
            return [h * 360, s * 100, l * 100]
        },
        hslToRgb(h, s, l) {
            h /= 360; s /= 100; l /= 100
            let r, g, b
            if (s === 0) {
                r = g = b = l
            } else {
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1
                    if (t > 1) t -= 1
                    if (t < 1 / 6) return p + (q - p) * 6 * t
                    if (t < 1 / 2) return q
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6
                    return p
                }
                const q = l < 0.5 ? l * (1 + s) : l + s - l * s
                const p = 2 * l - q
                r = hue2rgb(p, q, h + 1 / 3)
                g = hue2rgb(p, q, h)
                b = hue2rgb(p, q, h - 1 / 3)
            }
            return `rgb(${Math.round(r * 255)}, ${Math.round(g * 255)}, ${Math.round(b * 255)})`
        },
        getGradientColorByIndex(index, mainColor, valueFloor) {
            const [r, g, b] = this.hexToRgb(mainColor)
            const [h, s, baseL] = this.rgbToHsl(r, g, b)
            const maxDelta = 20
            const step = maxDelta / (valueFloor + 1)
            const startL = Math.max(0, baseL + (valueFloor - index) * step)
            const endL = Math.max(0, baseL + (valueFloor - index + 1) * step)
            return this.hslToRgb(h, s, (startL + endL) / 2)
        },
        getBlockStyle(prof, indBlock) {
            if (!this.hasIntervals(prof)) return {}
            const ind = indBlock - 1
            const valueFloor = this.getValueFloor(prof)
            const mainColor = this.getMainColor(prof)
            const background = ind < valueFloor
                ? this.getGradientColorByIndex(ind, mainColor, valueFloor)
                : mainColor + '30'
            return { background, borderColor: mainColor }
        },
        getBlockClass(prof, indProf, indBlock) {
            let ret = 'profnavigator-item-block'
            if (this.hasIntervals(prof)) {
                if (this.getScaleLimit > 12)
                    ret += ' profnavigator-item-block-dense'
                return ret
            }
            const v = this.getProfValue(prof)
            if (indBlock <= v)
                ret = indProf === 0 ? 'profnavigator-item-block-dark' : 'profnavigator-item-block-blue'
            if (this.getScaleLimit > 12)
                ret += ' profnavigator-item-block-dense'
            return ret
        },
    },
};
</script>


<style scoped lang="scss">
@import "src/assets/styles/variables";


.test-editor-results h3 {
    font-size: 1.6rem;
}

.test-editor-results .profnavigator-item {
    display: flex;
    align-items: center;
    margin: 20px 0;
}

.test-editor-results .profnavigator-bar-col {
    display: flex;
    flex-direction: column;
}

.test-editor-results .profnavigator-scale-names {
    display: flex;
    justify-content: space-around;
    font-size: 10px;
    line-height: 12px;
    color: #9e9e9e;
    margin-bottom: 3px;
}

.test-editor-results .profnavigator-scaleline {
    display: flex;
}

.test-editor-results .profnavigator-item-block {
    background: var(--color-block-light);
    width: 40px;
    height: 40px;
    border: 1px solid var(--color-block-blue);
    border-radius: 5px;
    margin-right: 1px;
    flex-shrink: 0;
}

.test-editor-results .profnavigator-item-block-dark {
    background: var(--color-block-dark);
    border-color: var(--color-block-dark);
}

.test-editor-results .profnavigator-item-block-blue {
    background: var(--color-block-blue);
    border-color: var(--color-block-blue);
}

.test-editor-results .profnavigator-item-value {
    margin-left: 30px;
    font-size: 16px;
    font-weight: bold;
}

.test-editor-results .profnavigator-item-title {
    margin-left: 30px;
    font-size: 16px;
    font-weight: bold;
}

.test-editor-results .profnavigator-item-block-dense {
    width: 20px;
    height: 20px;
}


.test-editor-results .desc-title {
    font-size: 20px;
    font-weight: bold;
}

.test-editor-results .desc-item-title {
    font-size: 16px;
    font-weight: bold;
    margin: 0px 0 8px 0;
}

.test-editor-results .desc-item {
    background: var(--color-bg);
    padding: 20px 10px 10px 20px;
    margin: 20px 0;
    border-radius: 5px;
}

.test-editor-results .desc-item-text {
    padding: 10px;
    border-radius: 10px;
}

.test-editor-results .desc-item-text p {
    margin-bottom: 5px !important;
}


@media screen and (max-width: 800px) {
    .test-editor-results .profnavigator-item-block {
        width: 28px;
        height: 30px;
    }
    .test-editor-results .profnavigator-item-block-dense {
        width: 12px;
        height: 20px;
    }
}

@media screen and (max-width: 600px) {
    .test-editor-results .profnavigator-item-block {
        width: 13px;
        height: 16px;
    }

    .test-editor-results .profnavigator-item {
        margin: 10px 0;
    }

    .test-editor-results .profnavigator-item-value {
        margin-left: 10px;
        font-size: 14px;
    }

    .test-editor-results .profnavigator-item-title {
        margin-left: 10px;
        font-size: 14px;
    }
    .test-editor-results .profnavigator-item-block-dense {
        width: 10px;
        height: 16px;
    }

}
.rep-top-title {
  font-size: 28px;
  color: #4f62a4;
}

.rep-test-title  {
  font-size: 24px;
}


</style>
